<template>
  <div class="our aboutUs" id='news'>
     <p class="our_common_title">新闻</p>
     <div class="news_list">
       <div class="news_item clearfix" v-for='item in news'>
          <router-link :to='"/m/our/news/detail/"+item.id'>
           <img :src="domain+item.litpic" alt="">
           <div class="news_text">
             <div class="news_text_title">
               {{item.title}}
             </div>
             <p class="news_text_time">{{item.updatetime | time}}</p>
           </div>
         </router-link>
       </div>
       <p class="more" @click='more' v-show='showmore'>加载更多</p>
     </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      news:[],
      limit:10,
      showmore:true,
    }
  },
  watch:{
    '$route':function(to,from){
      this.getList()
    }
  },
  mounted:function(){
    this.domain=this._routerRoot.domain
    this.getList()
  /*  var that = this
    $('#news').scroll(function(){
    　　var scrollTop = $(this).scrollTop();
    　　var scrollHeight = $(document).height();
    　　var windowHeight = $(this).height();
    　　if(scrollTop + windowHeight == scrollHeight){
          that.more()
    　　}
    });*/
  },
  methods:{
    getList:function(type){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_lists', this.$qs.stringify({
        cid:18,
        page:1,
        limit:this.limit
      }))
      .then(response => {
        console.log(response);
        this.news=response.data.data
        if(this.news.length<this.limit&&type==1){
          this.showmore=false;
          alertMessage('列表已全部加载完')
        }
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
    more(){
      this.limit+=10;
      this.getList(1)
    }
  }

}
</script>

<style scoped>
.aboutUs{

}
.banner{
  width: 100%;
  display: block;
}
.our_common_title{
  font-size: 0.36rem;
  font-weight: bold;
  color: #000;
  padding:0.3rem 0.2rem 0.5rem;
}
.news_list{
  padding:0 0.2rem;
}
.news_item:last-child{
  margin-bottom: 0;
}
.news_item {
  margin-bottom: 0.47rem;
}
.news_item img{
  width: 2.53rem;
  float: left;
  display: block;
  border-radius: 0.04rem;
}
.news_item .news_text{
  width: 3.26rem;
  float: right;
}
.news_text_title{
  font-size: 0.24rem;
  color: #000;
  line-height: 200%;
  padding-bottom: 0.1rem;
  border-bottom: 1px solid #d1d1d1;
  margin-bottom: 0.14rem;
}
.news_text_time{
  font-size: 0.24rem;
  color: #b2b2b2;
}
.more{
  font-size: 0.24rem;
  text-align: center;
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/news.vue